module.exports = __webpack_public_path__ + "static/media/bars.5e814560.svg";